import { DropdownOptionIntegerId } from '@/models/DropdownOptionIntegerId';
import { DropdownOption } from '@/models/DropdownOption';

export class TargetCalculationLookupData {
    calculationTypes: Array<DropdownOptionIntegerId>;
    calculationComplexities: Array<DropdownOption>;
}
